'use strict';

angular.module('randomization')
    .filter('randomizationMasked', [
        'RecordRandomizationService',
        'gettextCatalog',
        function(RecordRandomizationService, gettextCatalog) {
            return function(branch) {
                var branchId = angular.isObject(branch) ? branch.id : branch;
                branchId = parseInt(branchId, 10);

                var branches = RecordRandomizationService.getBranches();
                // Array.find() no esta disponible en IE, por lo que usaremos un bucle para encontrar el brazo
                var found = null;
                for (var index in branches) {
                    var branchDefinition = branches[index];

                    if (branchDefinition.id === branchId) {
                        found = branchDefinition;
                        break;
                    }
                }

                if (!found) {
                    return gettextCatalog.getString('(brazo eliminado)', null, 'randomization');
                }

                if (!('masked' in found)) {
                    return gettextCatalog.getString('(brazo no disponible)', null, 'randomization');
                }

                return found.masked;
            };
        },
    ]);
